module.exports = __webpack_public_path__ + "64cc797a8fe0b3d9176a6301c1cd0a22.svg";


//////////////////
// WEBPACK FOOTER
// ./~/demo-ui/asset/icon-font/fontello.svg
// module id = 698
// module chunks = 0